module.exports = __webpack_public_path__ + "06_mole.ead6dbf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer2/06_mole.png
// module id = hMbM
// module chunks = 0